import prettyBytes from 'pretty-bytes'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'


dayjs.extend(relativeTime)
dayjs.extend(utc)

export function bytes(bytes) {
  return prettyBytes(+bytes, {binary: true})
}

export function date(date) {
  return new Date(date).toLocaleDateString()
}

export function datetime(date) {
  return new Date(date).toLocaleString()
}

export function datetime2YearMonth(dateString) {
  const date = new Date(dateString)
  const options = {year: 'numeric', month: 'long'}
  return date.toLocaleDateString('en-US', options)
}

export function json(obj) {
  let res = JSON.stringify(obj, null, 2)
  return res == '{}' ? obj.toString() : res
}

export function daysAgo(time) {
  return time ? dayjs(time).fromNow() : undefined
}

export function daysAgoUTC(time) {
  return time ? dayjs.utc(time).local().fromNow() : undefined
}


export function normalizeDateRange(range){
  let [from, to] = range
  from = new Date(
    from.getFullYear(),
    from.getMonth(),
    from.getDate(),
    0, 0, 0, 0
  ).toISOString()

  to = new Date(
    to.getFullYear(),
    to.getMonth(),
    to.getDate(),
    23, 59, 59, 999
  ).toISOString()

  return [from, to]
}

export function normalizeDateRangeWithOffset(range) {
  const [from, to] = range
  const format = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

  return [
    dayjs(from).startOf('day').format(format),
    dayjs(to).endOf('day').format(format),
  ]
}
